jQuery(document).ready(function ($) {
  var $isotopeGrid = $('.isotope-grid').isotope({
    itemSelector: '.component-card-teaser',
    layoutMode: 'fitRows',
    filter: '*',
  });

  $isotopeGrid.imagesLoaded().progress(function () {
    $isotopeGrid.isotope('layout');
  });

  $.fn.statusfilter = function () {
    var filterneu = this.attr('id');
    $isotopeGrid.isotope({
      filter: filterneu,
    });
  };

  $('[id^=filter-status-]').click(function (event) {
    event.preventDefault();
    $(this).filter(14);
    $(this).setActive();
  });

  $('[id^=filter-category-]').click(function (event) {
    event.preventDefault();
    $(this).filter(16);
    $(this).setActive();
  });

  $.fn.filter = function (substringlenth) {
    var filterneu = '.' + this.attr('id').substring(substringlenth);
    $isotopeGrid.isotope({
      filter: filterneu,
    });
  };

  $.fn.setActive = function (scope) {
    $('[id^="filter-category"]').removeClass('is-active');
    $('[id^="filter-status"]').removeClass('is-active');
    $(this).addClass('is-active');
  };

   /* $.fn.grundrissfilter = function () {
    var filterneu = '.' + this.attr('id').substring(17);
    console.log(filterneu);
    $isotopeGrid.isotope({
      filter: filterneu,
    });
  };

  

  $('[id^=filter-]').click(function (event) {
    event.preventDefault();
    $(this).grundrissfilter();
    $(this).setActive();
  });

  $('#filter-grundriss-ohne').click(function (event) {
    event.preventDefault();
    $isotopeGrid.isotope({
      filter: '*',
    });
    $(this).setActive();
  });  */
});